import { useQuery } from "@apollo/client";
import { useMemo } from "react";
import { LIVE_EVENT_DETAIL_STATS } from "@/api/queries/liveEventDetailStats";
import { FilterState } from "@/components/FilterSidebar/FilterState";

export interface UseLiveEventDetailStatsReturn {
  statistics: {
    studentsWhoMessaged?: number | null;
    totalMessages?: number | null;
    totalChannelOpens?: number | null;
    totalParticipants?: number | null;
  } | null;
  loading: boolean;
  error: unknown;
}

export const useLiveEventDetailStats = (
  eventId: string,
  filterState?: FilterState | null,
): UseLiveEventDetailStatsReturn => {
  const { data, loading, error } = useQuery(LIVE_EVENT_DETAIL_STATS, {
    variables: {
      eventId,
      filters: filterState?.getQueryFilter() || undefined,
    },
    skip: !eventId,
  });

  const statistics = useMemo(() => {
    if (
      !data?.node ||
      data.node.__typename !== "LiveEvent" ||
      !data.node.statistics
    ) {
      return null;
    }

    return data.node.statistics;
  }, [data]);

  return {
    statistics,
    loading,
    error,
  };
};
